<template>
  <div style="width: 100%; height: 70px">
    <div
      ref="bgc"
      @mouseleave="handleMouseleave"
      style="display: flex; justify-content: center; width: 100%; height: 70px"
      :class="path == '/index' ? 'bagc' : 'noBgc'"
    >
      <div :class="path == '/index' ? 'w' : 'now'">
        <div style="" class="logoImg">
          <img
            :src="this.$store.state.m_user.logo"
            alt=""
            style="width: 272px !important; height: 42px !important"
            v-if="this.$store.state.m_user.logo != '' && this.$store.state.m_user.logo != null"
          />
          <img src="../../assets/images/homeLogo.png" alt="" style="width: 272px !important; height: 42px !important" v-else />
        </div>

        <div :class="path == '/' ? 'navBox active' : 'navBox'" @click="navGet('1')">
          网站首页
          <div class="bor"></div>
        </div>
        <div :class="path == '/courseSelection' ? 'navBox active' : 'navBox'" @click="navGet('2')">
          报名选课
          <div class="bor"></div>
        </div>

        <div :class="path == '/studyMain' ? 'navBox active' : 'navBox'" @click="navGet(7)">
          学习中心
          <div class="bor"></div> 
        </div>

        <div :class="path == '/tzgg' ? 'navBox active' : 'navBox'" @click="navGet(5)">
          公告资讯
          <div class="bor"></div>
        </div>
        <div :class="path == '/zscy' ? 'navBox active' : 'navBox'" @click="navGet(6)">
          证书查看
          <div class="bor"></div>
        </div>
        <div :class="path == '/zscy' ? 'navBox active' : 'navBox'" @click="navGet(11)">
          在线客服
          <div class="bor"></div>
        </div>

        <div
          class="loginBox"
          v-if="
            this.$store.state.m_user.realName == '' ||
            this.$store.state.m_user.realName == null ||
            this.$store.state.m_user.userName == '' ||
            this.$store.state.m_user.userName == null
          "
        >
          <!-- <div
          class="loginBox"
         v-if="this.$store.state.m_user.token==''||this.$store.state.m_user.token==null"
        > -->
          <span @click="regist">注册</span>/ <span @click="login">登录</span>
        </div>
        <div class="nologinBox" v-else>
          <div class="nameBox" @click="goStudy" v-if="this.$store.state.m_user.realName !== null">
            {{ this.$store.state.m_user.realName }}
          </div>
          <div class="nameBox" @click="goStudy" v-else>{{ this.$store.state.m_user.userName }}</div>
          <span style="margin: 0 10px; padding-bottom: 2px" class="su">|</span>
          <span @click="loginOut" class="noLogis">退出</span>
          <div class="note" @click="handleNote">
            <img src="../../assets/images/note.png" alt="" />
            <div class="count" v-if="this.$store.state.m_user.unReadCount != 0">{{ this.$store.state.m_user.unReadCount }}</div>
          </div>
        </div>
      </div>
    </div>
    <NoticeDialog :visible.sync="dialogTableVisible" />
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import NoticeDialog from '../component/NoticeDialog.vue';
import { logout } from '@/api/login.js';

import { mapMutations } from 'vuex';
import { getNoticeDetail } from '@/api/tzgg.js';
import { mapState } from 'vuex';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: { NoticeDialog },
  props: ['value'],
  metaInfo: {
    title: '筋斗云-安全生产学习平台 '
  },
  data() {
    // 这里存放数据
    return {
      dialogTableVisible: false,
      showTable: true, //列表详情切换
      gridData: [], //通知
      title: '线下培训班通知',
      // unReadCount: '', //未读人数
      iconSHow: false,
      indexShow: 1,
      logo: '',
      url: '',
      list: [],
      path: '',
      className: '',
      userName: '', //用户名称
      localValue: '',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      fp: '',
      token: '',
      infoDetail: {}
    };
  },
  // 监听属性 类似于data概念
  computed: {
    // localValue: {
    //   get() {
    //     return this.value; // 返回父组件传递的值
    //   }
    // }
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    ...mapMutations('m_user', ['REAL_NAME']),
    ...mapMutations('m_user', ['USER_NAME']),
    ...mapMutations('m_user', ['HEAD_LOGO']),
    ...mapMutations('m_user', ['SET_UNREAD_COUNT']),
    //打开通知弹框
    handleNote() {
      console.log(this.pageNum, '77');

      this.dialogTableVisible = true;
      this.pageNum = 1;
    },
    handleMouseleave() {
      this.$refs.bgc.style.background = 'none !important';
      this.$refs.bgc.style.transition = 'all 0.2s linear';
    },
    handleClose() {
      this.showTable = true;
      this.dialogTableVisible = false;
      this.pageNum = 1;
    },
    //点击姓名跳到学习中心
    goStudy() {
      this.$router.push({
        path: '/studyMain',
        query: {
          tabIndex: 4
        }
      });
    },
    handleDetail(row) {
      this.showTable = false;
      getNoticeDetail({ noticeId: row.noticeId }).then(res => {
        console.log(res);

        this.infoDetail = res.data.data;
      });
    },
    //更多
    moke() {
      this.$router.push({
        path: '/courseSelection'
      });
    },
    //目录点击
    goList(msg, item) {
      console.log(msg, item);
      this.$router.push({
        path: '/courseSelection',
        query: {
          codeNo: msg.codeNo, //第二级
          fCodeNo: item.codeNo //第一级
        }
      });
    },
    //退出登录
    loginOut() {
      this.$confirm('是否要退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.REAL_NAME('');
          localStorage.removeItem('token');
          localStorage.removeItem('realName');
          localStorage.removeItem('userName');
          this.token = '';
          console.log(this.token, '333');
          this.$store.commit('m_user/RESET_USER');
          localStorage.removeItem('bmShow');
          this.userName = '';
          logout({}).then(res => {
            this.$message({
              message: '退出登录成功！',
              type: 'success'
            });
            this.$router.push('/');
          });
        })
        .catch(() => {});
    },
    searClass(id) {
      if (this.className == '' && id !== 1) {
        return false;
      }
      this.localValue = {
        localValue: '',
        className: this.className
      };
      console.log(this.$route.path);
      this.$emit('updateParentValue', this.localValue); // 当输入框的值发生变化时，通过$emit事件告知父组件更新值
      if (this.$route.path !== '/courseSelection') {
        this.$router
          .push({
            path: '/courseSelection',
            query: {
              className: this.className
            }
          })
          .catch(err => {
            console.log('重复路由');
          });
      }
    },
    changeKe() {
      this.iconSHow = !this.iconSHow;
      console.log(this.iconSHow);
    },
    login() {
      this.$router.push('/login');
    },
    regist() {
      this.$router.push('/regist');
    },
    navGet(id) {
      this.indexShow = id;
      if (id == 1) {
        this.$router.push('/').catch(err => {
          console.log('重复路由');
        });
      } else if (id == 2) {
        //默认选中专业课
        this.$router.push({ path: '/courseSelection' }).catch(err => {
          console.log('重复路由');
        });
      } else if (id == 9) {
        this.$router.push('/zyjy').catch(err => {
          console.log('重复路由');
        });
      }
      // else if (id == 3) {
      //   this.$router.push('/car').catch(err => {
      //     console.log('重复路由');
      //   });
      // }
      else if (id == 4) {
        this.$router.push('/wzgn').catch(err => {
          console.log('重复路由');
        });
      } else if (id == 5) {
        this.$router.push('/tzgg').catch(err => {
          console.log('重复路由');
        });
      } else if (id == 6) {
        window.open('https://cx.mem.gov.cn/')
      } else if (id == 7) {
        this.$router.push('/studyMain').catch(err => {
          console.log('重复路由');
        });
      } else if (id == 8) {
        this.$router
          .push({
            path: '/studyMain1',
            query: {
              id: '8'
            }
          })
          .catch(err => {
            console.log('重复路由');
          });
      } else if (id == '10') {
        this.$router.push('/resourcesList').catch(err => {
          console.log('重复路由');
        });
      }else if (id == 11) {
        window.open('https://ahgcjykjyxgs.qiyukf.com/client?k=dafbd24366a8c31bb28f2737a1b7698e&wp=1&robotShuntSwitch=0&templateId=8136891&language=zh-cn&t=')
      } 
    },
    destroyed() {
      localStorage.removeItem('userName');
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.token = localStorage.getItem('token') || '';
    console.log(this.$store.state.m_user.token, 'nnn');

    if (this.$route.query.className) {
      this.className = this.$route.query.className;
    }
    this.path = this.$route.path;
    console.log(this.path);
    if (this.path == '/') {
      this.iconSHow = true;
    } else {
      this.iconSHow = false;
    }
    this.userName = localStorage.getItem('userName');
    console.log(this.$store.state.m_user.realName, this.$store.state.m_user.userName, '00ppp');
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    setTimeout(() => {
      this.url = this.$store.state.m_user.url;
      this.list = this.$store.state.m_user.list;
    }, 300);
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
/deep/.el-table__header,
.el-table__header-wrapper {
  background-color: #ebf3ff !important;
}
.nologinBox {
  // margin-left: 90px;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  display: flex;
  .nameBox {
    max-width: 83px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.now {
  position: relative;
  width: 1400px;
  height: 70px;
  display: flex;
  align-items: center;
  .logoImg {
    width: 252px;
    height: 42px;
    // background: url('../../assets/images/homeLogo.png') no-repeat 100% 100%;
    background-size: 100%;
    margin-right: 108px;
  }
  .navBox {
    width: 88px;
    text-align: center;
    height: 71px;
    line-height: 71px;
    margin-right: 48px;
    font-size: 16px;
    color: #fff;
    cursor: pointer;
    position: relative;
  }
  .loginBox {
    margin-left: 137px;
    width: 109px;
    height: 36px;
    border-radius: 18px 18px 18px 18px;
    border: 1px solid #ffffff;
    line-height: 36px;
    font-size: 14px;
    text-align: center;
    color: #fff;
    cursor: pointer;
  }
}
.w {
  position: fixed;
  top: 0;
  z-index: 9;
  width: 1400px;
  height: 72px;
  display: flex;
  align-items: center;
  .logoImg {
    width: 304px;
    height: 58px;
    // background: url('../../assets/images/homeLogo.png') no-repeat 100% 100%;
    background-size: 100%;
  }
  .navBox {
    width: 150px;
    text-align: center;
    height: 71px;
    line-height: 71px;
    margin-right: 4px;
    font-size: 16px;
    color: #fff;
    cursor: pointer;
    position: relative;
    .bor {
      opacity: 0;
      position: absolute;
      bottom: 0;
      width: 60px;
      height: 3px;
      background: linear-gradient(90deg, #6996ff 0%, #4076f6 100%);
      border-radius: 4px 4px 0px 0px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .loginBox {
    width: 150px;
    height: 70px;
    background: #3172f6;
    border-radius: 0px 0px 0px 0px;
    margin-left: 137px;
    width: 109px;
    height: 36px;
    border-radius: 18px 18px 18px 18px;
    // border: 1px solid #ffffff;
    line-height: 36px;
    font-size: 14px;
    text-align: center;
    color: #fff;
    cursor: pointer;
  }
}
.noBgc {
  background: #fff !important;
  cursor: pointer;
  transition: background-color 1s ease; /* 定义多个过渡 */
  .logoImg {
    width: 272px !important;
    height: 42px !important;
    // background: url('../../assets/images/homeLogo.png') no-repeat 100% 100% !important;
    background-size: 100% !important;
  }
  .navBox {
    font-size: 16px;
    color: #222222 !important;
    cursor: pointer;
    position: relative;
    .bor {
      opacity: 0;
      position: absolute;
      bottom: 0;
      width: 60px;
      height: 3px;
      background: linear-gradient(90deg, #6996ff 0%, #4076f6 100%);
      border-radius: 4px 4px 0px 0px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .loginBox {
    width: 150px;
    height: 70px;
    background: #3172f6;
    line-height: 70px;
    border-radius: 0px 0px 0px 0px;
    // border: 1px solid #dadada !important;
    // color: #999999 !important;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    cursor: pointer;
  }
  .nologinBox {
    width: 200px;
    // margin-left: 90px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    display: flex;
    align-items: center;
    .nameBox {
      max-width: 83px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .noLogis {
    width: 50px;
    color: #999;
  }
  .su {
    color: #666;
  }
  .navBox:hover {
    color: #4076f6 !important;
    cursor: pointer;
    .bor {
      opacity: 1 !important;
    }
  }
  .active {
    color: #4076f6 !important;
    .bor {
      opacity: 1 !important;
    }
  }
  // .loginBox:hover {
  //   // background: linear-gradient(103deg, #6996ff 0%, #4076f6 100%) !important;
  //   color: #4076f6 !important;
  //   // border: 0 !important;
  // }
}
// .bagc:hover {
//   background: #fff;
//   cursor: pointer;
//   transition: background-color 1s ease; /* 定义多个过渡 */
//   .logoImg {
//     width: 304px !important;
//     height: 58px !important;
//     background: url('../../assets/images/homeLogo.png') no-repeat 100% 100% !important;
//     background-size: cover !important;
//   }
//   .navBox {
//     font-size: 16px;
//     color: #222222 !important;
//     cursor: pointer;
//     position: relative;
//     .bor {
//       opacity: 0;
//       position: absolute;
//       bottom: 0;
//       width: 60px;
//       height: 3px;
//       background: linear-gradient(90deg, #6996ff 0%, #4076f6 100%);
//       border-radius: 4px 4px 0px 0px;
//       left: 50%;
//       transform: translateX(-50%);
//     }
//   }
//   .loginBox {
//     width: 150px;
//     height: 70px;
//     background: #3172f6;
//     border-radius: 0px 0px 0px 0px;
//     // border: 1px solid #dadada !important;
//     color: #999999 !important;
//     cursor: pointer;
//   }
//   .nologinBox {
//     display: flex;
//     margin-left: 90px;
//     height: 36px;
//     line-height: 36px;
//     font-size: 14px;
//     text-align: center;
//     color: #4076f6 !important;
//     cursor: pointer;
//   }
//   .navBox:hover {
//     color: #4076f6 !important;
//     cursor: pointer;
//     .bor {
//       opacity: 1 !important;
//     }
//   }
//   .active {
//     color: #4076f6 !important;
//     cursor: pointer;
//   }
//   .loginBox:hover {
//     // background: linear-gradient(103deg, #6996ff 0%, #4076f6 100%) !important;
//     color: #4076f6 !important;
//     // border: 0 !important;
//   }
// }
.note {
  width: 36px;
  height: 36px;
  background: #f4f6fa;
  border-radius: 18px 18px 18px 18px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  img {
    width: 23px;
    height: 22px;
  }
  .count {
    width: 15px;
    height: 15px;
    line-height: 15px;
    background: #ff0000;
    border-radius: 50%;
    position: absolute;
    top: 0;
    right: 0;
    color: #fff;
    font-size: 10px;
    text-align: center;
  }
}
.read {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  .cicle {
    width: 8px;
    height: 8px;
    background: #999999;
    border-radius: 50%;
    display: inline-block;
    margin-right: 6px;
  }
}
.noread {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  .cicle {
    width: 8px;
    height: 8px;
    margin-right: 6px;
    display: inline-block;
    background: #ff0000;
    border-radius: 50%;
  }
}
.back {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
  display: flex;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  img {
    width: 16px;
    height: 16px;
  }
}
.noteTitle {
  width: 100%;
  text-align: center;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 500;
  font-size: 18px;
  color: #333333;
  margin-bottom: 24px;
}
.time {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 400;
  font-size: 16px;
  color: #666666;
  text-align: center;
}
.content {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}
.btn_know {
  margin-top: 44px;
  display: flex;
  justify-content: center;
}
::v-deep .el-dialog__body {
  padding-top: 0 !important;
}
</style>
